import { render, staticRenderFns } from "./student-dashboard.vue?vue&type=template&id=3f81e6f4&scoped=true&"
import script from "./student-dashboard.vue?vue&type=script&lang=js&"
export * from "./student-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./student-dashboard.vue?vue&type=style&index=0&id=3f81e6f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f81e6f4",
  null
  
)

export default component.exports